module.exports = __webpack_public_path__ + "img/phone.5d046583.png";